import { useContext } from 'react';

import type { MsalContextValue } from '../../MsalProvider.types';

import { MsalContext } from '../../MsalProvider';

export function useMsalAuth(): MsalContextValue {
  const context = useContext(MsalContext);

  if (!context) {
    throw new Error('useMsalAuth must be used within MsalAuthProvider');
  }

  return context;
}
